export function getScoreName(name: string): string {
  switch (name) {
    //Reasoning
    case "T-Summ":
      return "Synthesis";
    case "T-Interp":
      return "Interpretation";
    case "T-Mem":
      return "Memory";
    //Mood
    case "stress":
      return "Stress";
    case "anxiety":
      return "Anxiety";
    case "depression":
      return "Depression";
    default:
      return "";
  }
}

export type ScoreOptions = Record<string, number>[];

export const buildScoreRange = (n: number): ScoreOptions => {
  const arr = [];
  for (let index = 0; index <= n; index++) {
    arr.push({ [index]: index });
  }
  return arr;
};
